<div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="room" role="tabpanel" aria-labelledby="general-tab">
        <div class="itinerary-tab-header">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" @click="redirectToRoomInfoEdit">
                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#hotelRoomEdit" role="tab" aria-controls="home" aria-selected="true">
                        <i class="fas fa-info-circle"></i>Edit Info
                    </a>
                </li>

                <li class="nav-item" @click="redirectToRoomGallery">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#hotelRoomGallery" role="tab" aria-controls="profile" aria-selected="false">
                        <i class="fas fa-images"></i>Gallery
                    </a>
                </li>
                <li class="nav-item" @click="redirectToRoomPackage">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#hotalRoomPackage" role="tab" aria-controls="profile" aria-selected="false">
                        <i class="fas fa-clock"></i> Package
                    </a>
                </li>

                <li class="nav-item" @click="redirectToRoomAmenity">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#roomAmenity" role="tab" aria-controls="profile" aria-selected="false">
                        <i class="fas fa-coffee"></i> Room Amenity
                    </a>
                </li>
                <!-- 
                <li class="nav-item" @click="redirectToTime">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#day3" role="tab" aria-controls="profile" aria-selected="false">
                        <i class="fas fa-clock"></i> Time
                    </a>
                </li>

                <li class="nav-item" @click="redirectToLocation">
                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#day4" role="tab" aria-controls="contact" aria-selected="false">
                        <i class="fas fa-map-marker-alt"></i> Location
                    </a>
                </li> -->
                <!-- 
                
               
                <li class="nav-item" @click="redirectToHighlights">
                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#day4" role="tab" aria-controls="contact" aria-selected="false">
                        <i class="fas fa-magic"></i> Highlights
                    </a>
                </li>
                <li class="nav-item" @click="redirectToImportantNotes">
                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#day3" role="tab" aria-controls="contact" aria-selected="false">
                        <i class="fas fa-exclamation-circle"></i> Important Notes
                    </a>
                </li> -->
            </ul>
            <div class="tab-content" id="">
                <router-view></router-view>
            </div>
        </div>
    </div>
</div>